// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mapId: __t.string().name("map_id"),
  name: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  tilesBlob: __t.byteArray().name("tiles_blob"),
  terrainBlob: __t.byteArray().name("terrain_blob"),
  spawnPointsJson: __t.string().name("spawn_points_json"),
  mapKind: __t.string().name("map_kind"),
  gridType: __t.string().name("grid_type"),
  rulesJson: __t.string().name("rules_json"),
  renderJson: __t.option(__t.string()).name("render_json"),
  biomeJson: __t.option(__t.string()).name("biome_json"),
  backendJson: __t.option(__t.string()).name("backend_json"),
});
